import { Component, inject } from '@angular/core';
import {
  ButtonClickEvent,
  CacBaseDialogComponent,
  CacDialogLayoutComponent,
  CacFieldComponent,
  CacImageUploaderComponent,
} from '@controladad/ng-base';
import { formControl, formGroup, Validators } from '@al00x/forms';
import { AttachmentApiService, BrandApiService, UploadResult } from '../../../services';
import { BrandEntity } from '@models';
import { extractName } from '../../../helpers';
import { of } from 'rxjs';

export type BrandDialogData = { brand?: BrandEntity };
export type BrandDialogResult = boolean;

@Component({
  selector: 'lib-brand-dialog',
  imports: [CacDialogLayoutComponent, CacFieldComponent, CacImageUploaderComponent],
  templateUrl: './brand-dialog.component.html',
  styleUrl: './brand-dialog.component.scss',
})
export class BrandDialogComponent extends CacBaseDialogComponent<BrandDialogData, BrandDialogResult> {
  private readonly brandApi = inject(BrandApiService);

  form = formGroup({
    englishName: formControl<string>(undefined, Validators.required),
    arabicName: formControl<string>(undefined, Validators.required),
    logo: formControl<UploadResult | string>(null),
  });

  constructor() {
    super();
    const values = this.data.brand;

    if (values) {
      this.form.patchValue({
        englishName: values.name.english,
        arabicName: values.name.arabic,
        logo: values.image?.url,
      });
    }
  }

  onSubmit(e: ButtonClickEvent) {
    const value = this.form.getRawValue();
    const brand = this.data.brand;

    const fields = { name: extractName(value), logoPath: this.getLogoPath(value.logo) };

    const request = brand
      ? this.brandApi.update({ brandId: brand.id, fields: fields })
      : this.brandApi.create({ fields });

    return request.pipe(e.pipe()).subscribe(() => this.submit(true));
  }

  private getLogoPath(logo: string | UploadResult | undefined): string | null {
    if (!logo) return null;

    const firstLogo = this.data.brand?.image?.path;

    return typeof logo === 'string' ? firstLogo || null : logo.imagePath || null;
  }
}
